export default __webpack_public_path__ + "static/media/book-animation.56ca14f3.gif";